/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RefreshTokenRequest {
    getFixupPrototypeFunction() { return RefreshTokenRequest.fixupPrototype; }

    static newInstance(model: Partial<RefreshTokenRequest>): RefreshTokenRequest {
        let obj = Object.assign(new RefreshTokenRequest(), model);
        RefreshTokenRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RefreshTokenRequest>): RefreshTokenRequest {
        if (!model) return null;
        return RefreshTokenRequest.newInstance(<RefreshTokenRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RefreshTokenRequest) {
        if (!obj) return;

        models.RefreshTokenRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RefreshTokenRequest): boolean {
        Object.setPrototypeOf(obj, RefreshTokenRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * access token obtained from the auth token api
     */
    access_token: string;

}
